// extracted by mini-css-extract-plugin
module.exports = {"root":"img-hover-switch_root__20x43","switchChilds":"img-hover-switch_switchChilds__1YHTk"};